import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from '@mui/material';

const SupportRequestModal = ({ open, onClose, onSubmit, errorMessage, onGoBack }) => {
    const [comment, setComment] = useState("");

    const handleSubmit = () => {
        onSubmit(comment);
        setComment("");
    };

    const parseErrorFields = (msg) => {
        if (!msg) return [];
        return msg.split(', ').filter(Boolean).map((part) => {
            const colonIdx = part.indexOf(':');
            if (colonIdx > 0) {
                return {
                    field: part.slice(0, colonIdx).trim().replace(/_/g, ' '),
                    message: part.slice(colonIdx + 1).trim(),
                };
            }
            return { field: null, message: part.trim() };
        });
    };

    const errorFields = parseErrorFields(errorMessage);
    const hasFieldErrors = errorFields.some((e) => e.field);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ color: 'black', fontWeight: 600 }}>
                Submission Error
            </DialogTitle>
            <DialogContent>
                <Box mb={2}>
                    <Typography variant="body1" gutterBottom>
                        We encountered an issue submitting your bond request.
                    </Typography>
                    {hasFieldErrors ? (
                        <Box sx={{ mb: 2, p: 1.5, bgcolor: '#fff0f0', borderRadius: 1, border: '1px solid #ffcdd2' }}>
                            <Typography variant="body2" color="error" sx={{ fontWeight: 600, mb: 1 }}>
                                The following fields have errors:
                            </Typography>
                            {errorFields.map((err, idx) => (
                                <Box key={idx} sx={{ display: 'flex', mb: 0.5 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500, textTransform: 'capitalize', minWidth: 140 }}>
                                        {err.field || 'Error'}:
                                    </Typography>
                                    <Typography variant="body2" color="error">
                                        {err.message}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    ) : errorMessage ? (
                        <Typography variant="body2" color="error" sx={{ mb: 2, p: 1, bgcolor: '#fff0f0', borderRadius: 1 }}>
                            Error: {errorMessage}
                        </Typography>
                    ) : null}
                    <Typography variant="body2" color="textSecondary">
                        {onGoBack
                            ? "You can go back to fix the errors, or create a support request for our team to review."
                            : "Would you like to create a support request? Our team can review your data and resume the application for you."}
                    </Typography>
                </Box>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Add a note (optional)"
                    fullWidth
                    multiline
                    rows={4}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    variant="outlined"
                    placeholder="Describe what you were trying to do..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                {onGoBack && (
                    <Button onClick={onGoBack} variant="outlined" color="primary">
                        Go Back and Fix
                    </Button>
                )}
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    Create Support Request
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SupportRequestModal;
